export default class TechnicalInfo {

  facility = null;
  type = "";

  firefighterLift = false;
  backupPower = false;
  firefighterFreeText = null;

  transportPerson = false;
  transportFreight = false;
  transportGoods = false;
  transportBed = false;
  transportCar = false;

  drive = "";
  maxPersons = null;
  maxLoad = null;
  operatingSpeed = null;
  cabinHeight = null;

  manufacturer = null;
  unknownManufacturer = "";
  assembler = null;
  unknownAssembler = "";
  buildYear = null;
  factoryNumber = "";

  laneStart = "";
  laneEnd = "";
  stations = null;
  loadingStations = null;

  buildingPermit = null;
  permissionToUse = null;

  keySafeExists = false;
  keySafeInfo = "";

  engineRoomExists = false;
  engineRoomPosition = "";
  engineRoomPositionInfo = "";
  doorPosition = "";
  awmModule = false;

  emergencyCallSystemGSM = false;
  emergencyCallSystemInfo = "";
  emergencyAnalog = false;
  emergencyPhoneNumber = "";

  updatedOn = null;
  updatedById = null;
  updatedByUsername = "";
  modernizedOn = null;

  cabinWidth = null;
  cabinDepth = null;

  control = "";
  frequencyConverter = "";

  cabinDoorType = null;
  cabinDoorWidth = null;
  cabinDoorHeight = null;

  shaftDoorType = null;
  shaftDoorWidth = null;
  shaftDoorHeight = null;

  doorSecurityType = null;
  emergencyType = [];

  knownOperator = false;
  liftAttendant = null;

  hydraulicDriveType = null;
  ropeDriveTypes = [];

  shaftProtectionType = null;

  shaftWidth = null;
  shaftDepth = null;
  shaftPitDepth = null;
  shaftHeadHeight = null;
  shaftDoorPortal = false;
  shaftDoorSurfaceType = null;

  warrantyEnd = null;

  reducedShaftHead = false;
  shaftPitEntry = false;
  reducedShaftPit = false;

  model = null;

  inclination = null;

  alternatingDirections = false;

  conveyingDirection = null;

  escalatorElevation = null;

  escalatorBearingHeight = null;

  escalatorStepWidth = null;

  escalatorWidth = null;

  escalatorStepLighting = false;

  power = null;

  energySavingOptionPresent = false;

  energySavingOption = null;

  technicalStandard = null;

  glassDoorPresent = false;

  glassDoorType = null;

  fireControlPresent= false;
  fireControlType = null;
  fireAlarmControlUnitPresent = false;

  connectedFacilities = [];
  connectedToMainFacility = [];
  connection = [];


  constructor() {
  }
}
